import Vue from 'vue'
import VueRouter from 'vue-router'
import TotalCarCostCalculator from '@/pages/total-car-cost-calculator'
import LenderDetails from '@/pages/lender-details'
import reportMixin from '@/mixin/reportMixin.js'

// 全局混入reportMixin，使所有组件都具有页面浏览上报功能
Vue.mixin(reportMixin)

Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

let routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		meta: { manualPageView: true },
	},
	{
		path: '/loans',
		name: 'loans',
		component: () => import(/* webpackChunkName: "loans" */ '../pages/loans.vue'),
	},
	{
		path: '/all-lenders',
		name: 'all-lenders',
		component: () => import(/* webpackChunkName: "loans" */ '../pages/loans.vue'),
	},
	{
		path: '/lenders-for-bad-credits',
		name: 'lenders-for-bad-credits',
		component: () => import(/* webpackChunkName: "lenders-for-bad-credits" */ '../pages/lenders-for-bad-credits.vue'),
	},
	{
		path: '/auto-loan-calculator',
		name: 'auto-loan-calculator',
		component: () => import(/* webpackChunkName: "auto-loan-calculator" */ '../pages/auto-loan-calculator.vue'),
	},
	{
		path: '/auto-lease-calculator',
		name: 'auto-lease-calculator',
		component: () => import(/* webpackChunkName: "auto-lease-calculator" */ '../pages/auto-lease-calculator.vue'),
	},
	{
		path: '/total-car-cost-calculator',
		name: 'total-car-cost-calculator',
		component: TotalCarCostCalculator,
	},

	{
		path: '/about-us',
		name: 'about-us',
		component: () => import(/* webpackChunkName: "about-us" */ '../pages/about-us.vue'),
	},
	{
		path: '/privacy-policy',
		name: 'privacy',
		component: () => import('../pages/privacy-policy.vue'),
	},
	{
		path: '/terms-of-service',
		name: 'terms',
		component: () => import('../pages/terms-of-service.vue'),
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		component: () => import('../pages/disclaimer.vue'),
	},
	{
		path: '/lenders/:lenderName/:id',
		name: 'LenderDetails',
		component: LenderDetails,
	},
	// 最后放置通配路由
	{
		path: '*',
		redirect: { name: 'home' },
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
